import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';
import { toggleClass } from '@opten/dom/toggle-class';
import Swiper, { HashNavigation, Keyboard, Mousewheel } from 'swiper';
import { PageRenderHelper } from './page-render-helper';
import { IFramePlayerComponent } from './player';
import { SectionScrollSlider } from './section-scroll-slider';
import { debounce } from '@opten/reactive/debounce';

Swiper.use([Keyboard, Mousewheel, HashNavigation]);

@Component({ className: 'js-section-slider' })
export class SectionSliderComponent {
	public swiper: Swiper;
	public innerContent: HTMLElement;
	public nav: HTMLElement;
	public navCurrent: HTMLElement;
	public navItems: HTMLElement[];

	constructor(private element: HTMLElement) {
		const slider = this.element.querySelector(
			'.js-section-slider-item'
		) as HTMLElement;
		const inner = this.element.querySelector(
			'.js-section-slider-inner'
		) as HTMLElement;
		this.innerContent = inner.querySelector(
			'.js-section-slider-inner-content'
		) as HTMLElement;
		const pageRenderHelper = new PageRenderHelper(
			this.innerContent,
			'.js-section-slider-inner-content'
		);
		const scrollSlider = new SectionScrollSlider(
			document.querySelector('.js-scroll-slider')
		);
		this.nav = document.querySelector(
			'.js-section-slider-nav'
		) as HTMLElement;
		this.navItems = Array.from(
			this.nav.querySelectorAll('.js-section-slider-nav-item')
		) as HTMLElement[];
		this.navCurrent = this.nav.querySelector(
			'.js-section-slider-nav-current'
		) as HTMLElement;
		const rootUrl = this.element.getAttribute('data-url');
		const rootTitle = this.element.getAttribute('data-title');
		let initSlide = parseInt(slider.getAttribute('data-init'));
		if (initSlide < 0) {
			initSlide = 0;
		}

		this.swiper = new Swiper(slider, {
			initialSlide: initSlide,
			direction: 'vertical',
			hashNavigation: {
				replaceState: false,
				watchState: true
			},
			autoHeight: true,
			speed: 1000,
			touchReleaseOnEdges: true,
			mousewheel: {
				releaseOnEdges: true
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			on: {
				afterInit: swiper => {
					const currentSlide = swiper.slides[swiper.activeIndex];
					this.setActiveNavItem(swiper);
					addClass(currentSlide, 'is-shown');
					if (!currentSlide.getAttribute('data-url')) {					
						addClass(scrollSlider.element, 'is-hidden');
					}
				},
				transitionStart: swiper => {
					swiper.slides.forEach(slide => {
						removeClass(slide, 'is-shown');
						const iframe = IFramePlayerComponent.getInstance(
							slide.querySelector('.js-player')
						);
						if (iframe) {
							iframe.pause();
						}
					});					
					addClass(scrollSlider.element, 'is-hidden');
				},
				transitionEnd: swiper => {
					const currentSlide = swiper.slides[swiper.activeIndex];
					this.setActiveNavItem(swiper);
					addClass(currentSlide, 'is-shown');
					const iframe = IFramePlayerComponent.getInstance(
						currentSlide.querySelector('.js-player')
					);
					if (iframe) {
						iframe.play();
					}
					if (currentSlide.getAttribute('data-url')) {
						removeClass(scrollSlider.element, 'is-hidden');
					}
				}
			}
		});

		if (this.navItems && this.navItems.length > 0) {
			this.navItems.forEach(item => {
				var slideIndex = parseInt(item.getAttribute('data-index'));
				item.addEventListener('click', e => {
					e.preventDefault();
					removeClass(document.body, 'header-is-open');
					if (isNaN(slideIndex) == false) {
						scrollSlider.close(true).then(
							() => {
								//pageRenderHelper.close();
								this.swiper.slideTo(slideIndex);
							},
							() => {
								//pageRenderHelper.close();
								this.swiper.slideTo(slideIndex);
							}
						);
					}
				});
			});
		}

		if (window.scrollY > 0) {
			if (hasClass(document.body, 'content-is-open') == false) {
				window.scrollTo({
					top: 0,
					behavior: 'auto'
				});
			} else {
				this.swiper.disable();
			}
		}

		window.addEventListener('scroll', () => {
			const scrollTop = Math.max(
				document.documentElement.scrollTop,
				document.body.scrollTop,
				window.scrollY
			);
			toggleClass(document.body, 'has-scrolled', scrollTop > 0);
			if (scrollSlider.isOpen == false) {
				if (scrollTop > 0) {
					this.swiper.disable();
				} else {
					this.swiper.enable();
				}
			}
			// at bottom
			if (
				scrollSlider.isOpen &&
				hasClass(document.body, 'content-is-ready') &&
				scrollTop > 0 &&
				Math.max(
					document.documentElement.scrollHeight,
					document.body.scrollHeight
				) <=
					scrollTop + window.innerHeight + 20
			) {
				if (document.querySelector('.js-section-slider-next')) {
					const nextIndex = this.swiper.activeIndex + 1;
					this.swiper.enable();
					this.swiper.slideTo(nextIndex, 0, false);
					scrollSlider.close().then(
						() => {
							// this.swiper.enable();
							// pageRenderHelper.close();
							// this.swiper.slideTo(nextIndex, 0, true);
						},
						() => {
							// this.swiper.enable();
							// pageRenderHelper.close();
							// this.swiper.slideTo(nextIndex, 0, true);
						}
					);
				}
			}
		});

		scrollSlider.input.addEventListener('input', (e: any) => {
			const url =
				this.swiper.slides[this.swiper.activeIndex].getAttribute(
					'data-url'
				);
			if (
				scrollSlider.isOpen == false &&
				e.target.value > 0 &&
				this.innerContent.getAttribute('data-url') != url
			) {
				pageRenderHelper.clear();
			}
		});

		SectionScrollSlider.onStateChange.subscribe(isOpen => {
			if (isOpen) {
				this.swiper.disable();
				const url =
					this.swiper.slides[this.swiper.activeIndex].getAttribute(
						'data-url'
					);
				pageRenderHelper
					.fetch(url)
					.then(newContent => {})
					.catch(error => {})
					.finally(() => {});
			} else {
				const slideHash =
					this.swiper.slides[this.swiper.activeIndex].getAttribute(
						'data-hash'
					);
				pageRenderHelper.close(rootUrl + '#' + slideHash, rootTitle);
				this.swiper.enable();
			}
		});

		var allIframes = Array.from(
			document.querySelectorAll<HTMLElement>('.js-section-hide')
		);		
		
		document.addEventListener(
			'scroll',
			debounce(() => {
				var hideScrolSection = false;
				allIframes.forEach(iframe => {
					var bonuceScrolSlider = scrollSlider.element.getBoundingClientRect();										
					var state = this.elementsCollide(bonuceScrolSlider, iframe);									
					if (state) {						
						hideScrolSection = true;
					}					
				});											
				if (this.chapterValue(this.swiper)) {																				
					if (hideScrolSection) {
						if (!hasClass(scrollSlider.element, 'is-hidden')) {														
							scrollSlider.element.classList.add('is-hidden');
						}
					} else {
						if (hasClass(scrollSlider.element, 'is-hidden')) {									
							scrollSlider.element.classList.remove('is-hidden');
						}
					}
				}												
			}, 200)
		);
	}

	private chapterValue(swiper: Swiper) {
		return swiper.slides[swiper.activeIndex].getAttribute(
			'data-url'
		);
	}

	private elementsCollide(rect1, el2) {
		var rect2 = el2.getBoundingClientRect();

		return !(
			rect1.top > rect2.bottom ||
			rect1.right < rect2.left ||
			rect1.bottom < rect2.top ||
			rect1.left > rect2.right
		  );
	}

	private setActiveNavItem(swiper: Swiper) {
		toggleClass(document.body, 'is-at-start', swiper.activeIndex == 0);
		toggleClass(
			document.body,
			'is-at-end',
			swiper.activeIndex == swiper.slides.length - 1
		);
		this.navCurrent.innerHTML = (swiper.activeIndex + 1)
			.toString()
			.padStart(2, '0');
		if (this.navItems && this.navItems.length > 0) {
			this.navItems.forEach(item => removeClass(item, 'is-active'));
			const activeItem = this.navItems[swiper.activeIndex];
			addClass(activeItem, 'is-active');
		}
	}
}
